import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IUploadSiteMdmDataResultEntry } from "../../services/MdmImport/type";

const LOCAL_STORAGE_KEY = "mdm_import_upload_result";

interface MdmImportState {
  uploadResult: IUploadSiteMdmDataResultEntry[];
}

const loadFromLocalStorage = (): IUploadSiteMdmDataResultEntry[] => {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as IUploadSiteMdmDataResultEntry[];
  } catch {
    return [];
  }
};

const saveToLocalStorage = (data: IUploadSiteMdmDataResultEntry[]) => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
  } catch {
    // localStorage unavailable — silently ignore
  }
};

const initialState: MdmImportState = {
  uploadResult: loadFromLocalStorage(),
};

export const mdmImportSlice = createSlice({
  name: "mdmImport",
  initialState,
  reducers: {
    setMdmUploadResult: (
      state,
      action: PayloadAction<IUploadSiteMdmDataResultEntry[]>,
    ) => {
      state.uploadResult = action.payload;
      saveToLocalStorage(action.payload);
    },
    clearMdmUploadResult: (state) => {
      state.uploadResult = [];
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    },
  },
});

export const { setMdmUploadResult, clearMdmUploadResult } =
  mdmImportSlice.actions;

export const selectMdmUploadResult = (state: {
  mdmImport: MdmImportState;
}): IUploadSiteMdmDataResultEntry[] => state.mdmImport.uploadResult;

export default mdmImportSlice.reducer;
